/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { SessionTimeout } from './SessionTimeout';
import App from 'apmui/App';
import EventTags from 'apmui/EventTags';
import { getLandingUri } from 'apmui/common/modelAPI';
import { DialogClass, DialogType, DialogPriority } from 'apmui/components/dialog/Model';
import edgeClient from 'apmui/plugin/edgeClient';
import { divLog } from 'apmui/util/divLog';

/* Ensure correct registration order */
import 'apmui/components/dialog/Controller';
import { PAGE } from 'apmui/page';

/**
 * Session Timeout controller module.
 */
const app = App.get();
const client = edgeClient();

const sessionTimeout = new SessionTimeout({
    autostart: false,
    callback: (event: any) => {
        divLog('SessionTimeout:', event.message);
        if (!event.tin) {
            app.dispatch(EventTags.TIMEOUT);
        }
    },
});

app.subscribeDefault(EventTags.START, (event, store) => {
    if (store.general.controllers.policyTimeout) {
        sessionTimeout.start();
    }
});

app.subscribe(
    EventTags.TIMEOUT,
    (event, store) => {
        divLog('Session Timeout Controller: Session is timed out');
        sessionTimeout.stop();
        app.showModal(DialogType.SESSION_TIMEOUT);
    },
    { last: true, default: true }
);

app.subscribe(EventTags.DIALOG_OPEN, ({ detail }, store) => {
    if (detail.dialog === DialogType.SESSION_TIMEOUT) {
        detail.dialog = {
            class: DialogClass.TIMEOUT,
            id: detail.dialog,
            title: store.general.policyTimeout.message,
            body: `<a class="apmui-button apmui-button-submit" href="${getLandingUri(store)}">${
                store.general.policyTimeout.newSessionMessage
            }</a>`,
            entries: [],
            priority: DialogPriority.HIGH_PRIORITY,
        };
    }

    if (store.pageType !== PAGE.WEBTOP && client.hasClearSession()) {
        client.clearSession();
    }
});
